import { useRedux } from "shared/lib/useRedux"

export function useAPIHealth() {
  return useRedux(({ health }) => health.endpointHealth)
}
